import Head from 'next/head';
import { motion } from 'framer-motion';
import JoinUsBanner from './joinUsBannerComponent';
import * as Boxes from './styles/blocks';
import Footer from './Footer';
import ClaimBanner from '../features/banners/ClaimBanner';

function Layout({ children, title, description, className, hideFooter, hideJoinUs }) {
  return (
    <Boxes.Block className={className} id="app-layout" minHeight="100vh" paddingY="100px" paddingMdT="80px" paddingMdB="0">
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="shortcut icon" href="/favicon.ico" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      
      {children}
      
      {!hideJoinUs && false &&(
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1, delay: 1 }}
        >
          
          <JoinUsBanner />
        </motion.div>
      )}

      {!hideFooter && <Footer />}
      <ClaimBanner /> 
    </Boxes.Block>
  );
}

Layout.defaultProps = {
  title: 'Pirates of the Metaverse',
  description: 'NFT Pirates',
};

export default Layout;
